import React from "react";
import { RydToggleButton } from "../widgets/RydToggleButton";
import {
    useSetWorkspaceUIState,
    useWorkspaceUIState
} from "../../stores/WorkspaceStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import NoteDurationSelector from "../pickers/DurationSelector";
import { GridResolutionDialog } from "../pickers/GridResolutionDialog";
import RydRollHeaderGroup from "../widgets/RydRollHeaderGroup";


export function WorkspaceEditControls() {

    const workspaceUiState = useWorkspaceUIState();
    const setWorkspaceUIState = useSetWorkspaceUIState();

    return (<RydRollHeaderGroup>
        <RydToggleButton
            active={workspaceUiState.editMode === 'NOTES'}
            onActivate={() => {
                setWorkspaceUIState({ ...workspaceUiState, editMode: 'NOTES' });
            }}
            onDeactivate={() => {
                setWorkspaceUIState({ ...workspaceUiState, editMode: 'SELECT' });
            }}
            activeStyle={{
                backgroundColor: 'orange',
                // color: 'var(--md-sys-color-on-primary-container)'
                color: 'black'
            }}
            inactiveStyle={{
                backgroundColor: 'lightgrey',
                color: 'black'
            }}
        ><FontAwesomeIcon icon={faPen} /></RydToggleButton>
        <NoteDurationSelector
            updateSelectedDuratonCB={(resolution) => {
                setWorkspaceUIState({ ...workspaceUiState, newNoteDuration: resolution })
            }}
            duration={workspaceUiState.newNoteDuration} />
        <GridResolutionDialog
            resolution={workspaceUiState.gridResolution}
            setResolution={(resolution) => {
                setWorkspaceUIState({ ...workspaceUiState, gridResolution: resolution });
            }}
            snap={workspaceUiState.snapToGrid}
            setSnap={(s) => setWorkspaceUIState({ ...workspaceUiState, snapToGrid: s })}
        />
    </RydRollHeaderGroup>);
}